// constants to define the state of the app for analytics
export const DashboardPage = "dashboard";
export const MapPage = "map";
export const TablePage = "table";

export enum FetchStatus {
	IDLE = "IDLE",
	LOADING = "LOADING",
	SUCCESS = "SUCCESS",
	FAILURE = "FAILURE",
}
